/*
 * Created by: cparaschiv
 * Date: 14.12.2012, 12:57
 */

/** @module TS.MsgBox */

/**
 *  A jQuery [Promise]{@link https://api.jquery.com/promise/} object.
 * @typedef Promise
 * */

TS.MsgBox = TS.MsgBox || {};

(function() {
    'use strict';

    function buildMessageBody(items) {
        var wrapFunc = function(item) {
            return '<li>' + item + '</li>';
        };
        var ret = items.map(wrapFunc);
        ret = '<ul>' + ret + '</ul>';
        return ret;
    }

    /** @exports TS.MsgBox*/
    $.extend(TS.MsgBox, {

        /**
         * Shows a message box to the user.
         * @param title {String}
         * @param message {String}
         * @param callback {Function} Function to be called when the user presses the OK button.
         * @static
         */
        show: function (title, message, callback) {
            if (TS.isArray(message)) {
                message = buildMessageBody(message);
            }
            var options = {
                message: message,
                title: title,
                animate: false,
                backdrop: 'static', // 'static' instead of true; does not dismiss the dialog when clicking outside
                onEscape: callback || $.noop,
                buttons: {
                    ok: {
                        'class': 'btn-primary btn-large',
                        label: 'OK',
                        callback: callback
                    }
                }
            };
            bootbox.dialog(options);
            /*
            bootbox.dialog(message, {
                'class': 'btn-primary btn-large',
                label: 'OK',
                callback: callback
            }, {
                header: title,
                animate: false,
                backdrop: 'static', // 'static' instead of true; does not dismiss the dialog when clicking outside
                onEscape: callback || $.noop
            });*/
        },

        /**
         * Shows a confirmation message.
         * Note that MsgBox methods are asynchronous. Unlike a regular JavaScript alert (which will halt browser execution),
         * showing a MsgBox will not cause the code to stop. If you have code that should only run after user feedback
         * you must use a callback function.
         * @param title {String}
         * @param message {String}
         * @param confirmButtonText {String}
         * @param okCallback {Function} Function to be called when the user presses the OK button.
         * @param cancelCallback {Function} Function to be called when the user presses the Cancel button.
         * @static
         */
        confirm: function (title, message, confirmButtonText, okCallback, cancelCallback) {
            var culture = TS.cultures.current;

            var options = {
                message: message,
                title: title || culture.common.Confirm,
                animate: false,
                backdrop: 'static', // 'static' instead of true; does not dismiss the dialog when clicking outside
                onEscape: cancelCallback || $.noop,
                buttons: {
                    ok: {
                        "label": confirmButtonText || culture.common.Yes,
                        "class": "btn-primary",
                        "callback": okCallback
                    },
                    cancel: {
                        "label": culture.common.Cancel,
                        "class": "btn-default",
                        "callback": cancelCallback
                    }
                }
            };

            bootbox.dialog(options);
            /*
            bootbox.dialog(message, [
                {
                    "label": confirmButtonText || culture.common.Yes,
                    "class": "btn-primary",
                    "callback": okCallback
                },
                {
                    "label": culture.common.Cancel,
                    "class": "btn-default",
                    "callback": cancelCallback
                }
            ], {
                header: title || culture.common.Confirm,
                animate: false,
                backdrop: 'static', // 'static' instead of true; does not dismiss the dialog when clicking outside
                onEscape: cancelCallback || $.noop
            });*/
        },

         /**
         * Shows a confirmation message.
         * Note that MsgBox methods are asynchronous. Unlike a regular JavaScript alert (which will halt browser execution),
         * showing a MsgBox will not cause the code to stop. If you have code that should only run after user feedback
         * you must use a callback function.
         * @param title {String}
         * @param message {String}
         * @param confirmButtonText {String}
         * @param okCallback {Function} Function to be called when the user presses the Yes button.
         * @param noCallback {Function} Function to be called when the user presses the No button.
         * @param cancelCallback {Function} Function to be called when the user presses the Cancel button.
         * @static
         */
        confirmYesNoCancel: function (title, message, yesCallback, noCallback, cancelCallback) {
            var culture = TS.cultures.current;
            if (!cancelCallback)
                cancelCallback = $.noop;

            var options = {
                message: message,
                title: title || culture.common.Confirm,
                animate: false,
                backdrop: 'static', // 'static' instead of true; does not dismiss the dialog when clicking outside
                onEscape: cancelCallback,
                buttons: {
                    ok: {
                        "label": culture.common.Yes,
                        "className": "btn-primary",
                        "callback": yesCallback
                    },
                    no : {
                        "label": culture.common.No,
                        "callback": noCallback
                    },
                    cancel: {
                        "label": culture.common.Cancel,
                        "callback": cancelCallback 
                    }
                }
            };

            bootbox.dialog(options);
        },

        /**
         * Shows a confirmation message.
         * Note that MsgBox methods are asynchronous. Unlike a regular JavaScript alert (which will halt browser execution),
         * showing a MsgBox will not cause the code to stop. If you have code that should only run after user feedback
         * you must use a callback function.
         * @param title
         * @param message
         * @param confirmButtonText {String}
         * @returns {Promise}
         * @static
         */
        promiseConfirmation: function (title, message, confirmButtonText) {
        	var dfd = new $.Deferred(),
        		culture = TS.cultures.current,
				okCallback = function () {
            		dfd.resolve(true);
				}, cancelCallback = function () {
            		dfd.resolve(false);
				},
				options = {
					message: message,
					title: title || culture.common.Confirm,
					animate: false,
					backdrop: 'static', // 'static' instead of true; does not dismiss the dialog when clicking outside
					onEscape: cancelCallback || $.noop,
					buttons: {
						ok: {
							"label": confirmButtonText || culture.common.Yes,
							"class": "btn-primary",
							"callback": okCallback
						},
						cancel: {
							"label": culture.common.Cancel,
							"class": "btn-default",
							"callback": cancelCallback
						}
					}
				};

            bootbox.dialog(options);

			/*
            bootbox.dialog(message, [
                {
                    "label": confirmButtonText || TS.cultures.current.common.Yes,
                    "class": "btn-primary",
                    "callback": function () {
                        dfd.resolve(true);
                    }
                },
                {
                    "label": TS.cultures.current.common.Cancel,
                    "class": "btn-default",
                    "callback": function () {
                        dfd.resolve(false);
                    }
                }
            ], {
                header: title || TS.cultures.current.common.Confirm,
                animate: false,
                backdrop: 'static', // 'static' instead of true; does not dismiss the dialog when clicking outside
                onEscape: function () {
                }
            });
			*/

            return dfd.promise();
        }
    });

})();
